// src/service/orderService.js

export const sendOrderData = async (params, lang) => {
    try {
        console.log("Sending data:", params);

        const apiUrl = `${process.env.VUE_APP_API_URL}/rma/orderData`;
        console.log(apiUrl)
        const requestOptions = {
            method: "POST",
            headers: { 
                "Content-Type": "application/json",
                "Accept-Language": lang
            },
            body: JSON.stringify(params),
        };

        const response = await fetch(apiUrl, requestOptions);
        const json = await response.json()
        // console.log(`Out of response ${json.message}`)

        if (!response.ok) {
            throw new Error(`${json.message}`);

        }

        return json; // Return API response

    } catch (error) {
        console.error("Error sending order data:", error);
        throw error;
    }
};
